import React from 'react';
import ContentLoader from 'react-content-loader';

const RegistrationFormsPageSkeleton: React.FC = () => (
  <div className="pb-[16px]">
    <ContentLoader height="320" width="100%" className="mb-4">
      <rect x="0" y="0" rx="8" ry="8" className="w-full h-full" />
    </ContentLoader>
    <hr className="-mx-6" />
    <div className="flex justify-end mt-4">
      <ContentLoader height="36" width="160">
        <rect x="0" y="0" rx="8" ry="8" className="w-full h-full" />
      </ContentLoader>
    </div>
  </div>
);

export default RegistrationFormsPageSkeleton;
